module.exports = "https://cdn.dove.it/_next/static/public/assets/come-funziona-costruttori.09d7a2761a0893ee68ebe5330b5d1c44.png";